/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Error_Ortryagainlater3Inputs */

const en_analytics_error_ortryagainlater3 = /** @type {(inputs: Analytics_Error_Ortryagainlater3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`or try again later.`)
};

/**
* | output |
* | --- |
* | "or try again later." |
*
* @param {Analytics_Error_Ortryagainlater3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const analytics_error_ortryagainlater3 = /** @type {((inputs?: Analytics_Error_Ortryagainlater3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Error_Ortryagainlater3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_analytics_error_ortryagainlater3(inputs)
});
export { analytics_error_ortryagainlater3 as "analytics_error_orTryAgainLater" }